// Template228: Kuala Lumpur - Excursiones (Page12)
// Portada Excursiones + sticker, intro, Putrajaya (img + text + SabiasQue), info box Putrajaya, Melaka (text + img + SabiasQue), info box Genting (SabiasQue + title + body).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template228 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const titleOverlay = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const block1Title = page?.texts?.[3]?.content;
	const block1Body = page?.texts?.[4]?.content;
	const infoBox1 = page?.texts?.[5]?.content;
	const block2Title = page?.texts?.[6]?.content;
	const block2Body = page?.texts?.[7]?.content;
	const block3Title = page?.texts?.[8]?.content;
	const block3Body = page?.texts?.[9]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#2E7D5B";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt=""
							sx={{ width: 100, position: "absolute", bottom: 55, left: 21 }}
						/>
					)}
					{titleOverlay && (
						<Box
							component="h1"
							sx={{
								fontSize: 32,
								position: "absolute",
								bottom: 0,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
								margin: 1.25,
							}}
						>
							{titleOverlay}
						</Box>
					)}
				</Box>
			)}

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
					<Box component="p" sx={{ ...estiloP, color: "#333" }}>
						{intro}
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-2"
				sx={{
					padding: "10px 12px",
					paddingTop: 0,
					display: "flex",
					flexDirection: "column",
					gap: 1.75,
				}}
			>
				{/* Putrajaya */}
				<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, position: "relative" }}>
					{img1 && (
						<Box
							component="img"
							src={img1}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{block1Title && (
							<Box component="h3" sx={estiloH3}>
								{block1Title}
							</Box>
						)}
						{block1Body && (
							<Box component="p" sx={estiloP}>
								{block1Body}
							</Box>
						)}
					</Box>
					{sabiasQue[0] && (
						<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
							<SabiasQue
								icono={sabiasQue[0].icono}
								texto={sabiasQue[0].texto}
							/>
						</Box>
					)}
				</Box>

				{infoBox1 && (
					<Box
						data-block-id="text-4"
						sx={{
							backgroundColor: "#dee7e3",
							padding: 1.5,
							borderRadius: "12px",
							display: "flex",
							gap: 2,
							alignItems: "center",
						}}
					>
						<Box component="p" sx={estiloP}>
							{infoBox1}
						</Box>
					</Box>
				)}

				{/* Melaka */}
				<Box data-block-id="text-5" sx={{ display: "flex", gap: 2, position: "relative" }}>
					<Box sx={{ width: "60%" }}>
						{block2Title && (
							<Box component="h3" sx={estiloH3}>
								{block2Title}
							</Box>
						)}
						{block2Body && (
							<Box component="p" sx={estiloP}>
								{block2Body}
							</Box>
						)}
					</Box>
					{img2 && (
						<Box
							component="img"
							src={img2}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					{sabiasQue[1] && (
						<Box
							sx={{
								position: "absolute",
								top: 0,
								right: isSmallScreen ? "32%" : "36%",
							}}
						>
							<SabiasQue
								icono={sabiasQue[1].icono}
								texto={sabiasQue[1].texto}
							/>
						</Box>
					)}
				</Box>

				{/* Genting Highlands - info box con SabiasQue */}
				<Box
					data-block-id="text-6"
					sx={{
						backgroundColor: "#dee7e3",
						padding: 1.5,
						borderRadius: "12px",
						display: "flex",
						gap: 2,
						alignItems: "center",
						position: "relative",
					}}
				>
					{sabiasQue[2] && (
						<Box
							sx={{
								position: "absolute",
								top: isSmallScreen ? -20 : -30,
								left: "33%",
							}}
						>
							<SabiasQue
								icono={sabiasQue[2].icono}
								texto={sabiasQue[2].texto}
							/>
						</Box>
					)}
					<Box sx={{ width: "100%" }}>
						{block3Title && (
							<Box component="h3" sx={estiloH3}>
								{block3Title}
							</Box>
						)}
						{block3Body && (
							<Box component="p" sx={estiloP}>
								{block3Body}
							</Box>
						)}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template228.thumbnail = "/images/template-1.png";
export default Template228;
